<template>
  <div v-if="content.show" class="field" :class="content.errorMessage?'errorBorder':''">
    <p class="text">
      <span>{{content.order}}</span>{{content.title}}
    </p>
    <div class="scale-rating">
      <table>
        <template v-for="(pep,zindex) in content.subTitle">
          <tr>
            <th colspan="10">
              <div class="left-side">{{content.subTitle[zindex][0]}}</div>
              <div class="right-side">{{content.subTitle[zindex][1]}}</div>
            </th>
          </tr>
          <tr>
            <td v-for="(item,index) in selected[zindex].length" @click="selectCurrent(index,content.num,content.type,item,zindex)">
              <a class="rate-off rate-off2" :class="selected[zindex][index]?'rate-on  rate-on2':''"></a>
            </td>
          </tr>
        </template>
      </table>
    </div>

    <div class="errorMessage">{{content.errorMessage}}</div>
  </div>
</template>
<script>
export default {
  props:{
    content: Object
  },
  data() {
    return {
      answer: ['1', '2', '3', '4', '5', '6', '7', '8', '9'],
      selected:[
        [false, false, false, false, false, false, false, false, false],
        [false, false, false, false, false, false, false, false, false]
      ]
    }
  },
  methods:{
    selectCurrent(index, num, type, item, s) {
      let value = [false, false, false, false, false, false, false, false, false]
      value.map((pep,i)=>{
        if(i<=index){
          value[i] = true
        }
      })
      if (s + 1) {
        this.$set(this.selected, s, value)
      }else{
        this.$set(this.selected, 0, value)
      }
      this.$emit("listenToChildEvent", index + 1, num, type, s + 1);
    }
  }
}
</script>
<style lang="stylus" scoped>
  .scale-rating
    width:94%
    background-color: #ffffff
    margin:auto
    padding:0.1rem
    border: 1px solid #d5d5d5
  table th
    padding:0.16rem 0
    width: 9%
    text-align:center
    font-weight:normal
    overflow:hidden
  table td
    border-top: 1px solid #dbdbdb
    padding: 0.2rem 0
    text-align :center
    .rate-off
      width: 21px
      height: 21px
      text-decoration: none
      border-radius: 30px
      color: #333
      border: 1px solid #cacece
      cursor: default
      display: inline-block
      background: #fafafa
      line-height: 19px
      text-align: center
    .rate-on
      background-color: #53a4f4 !important
      border: 1px solid #53a4f4
      position: relative
      color: #fff
    .rate-on2
      background: url(../images/wjxstar.png) !important
      background-position: 0 -28px !important
    .rate-off2
      background: url(../images/wjxstar.png)
      border-radius: 0
      box-shadow: none
      border: 0
      padding: 2px
</style>
